import { EVENT_TOPIC_FOR_TRANSACTION_SERVER } from "../../common/common";

function GetEventTableData(eventName, actionFn) {
    document.addEventListener(eventName, actionFn);
}

function DeleteEventTableData(eventName, actionFn) {
    //console.log('DeleteEventTableData, eventName: ' + eventName)
    document.removeEventListener(eventName, actionFn);
}

function PublishEventTableData(eventName, data) {
    //console.log("PublishEventTableData, eventName: " + eventName + ", data: " + data);
    const event = new CustomEvent(eventName, { detail: { message: data }, bubbles: false, composed: false });
    document.dispatchEvent(event);
}

export { PublishEventTableData, GetEventTableData, DeleteEventTableData };

export const DispatchTableEvent = (eventType, tableName, rowData) => {
    // console.log(`Events.js Dispatching ${tableName}:`, eventType, rowData);
    const event = new CustomEvent(`${tableName}`, {
        detail: { type: eventType, data: rowData },
    });
  
    // console.log(`Events.js Dispatched ${tableName}:`, event.detail, "type: ", event.detail.type, ", data: ", event.detail.data);
    window.dispatchEvent(event);
};

export const DispatchTransactionEvent = (type, sub_type, data = {}) => {
    const event = new CustomEvent(EVENT_TOPIC_FOR_TRANSACTION_SERVER, {
        detail: {
            type,     
            sub_type,
            data,     
        },
    });

    window.dispatchEvent(event);
};
